import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDate, formatSeconds, formatTime } from "~/modules/app/util/formatters";

import { TimeReportsVisitSummaryFragment } from "./fragments.generated";

interface TimeReportsVisitSummaryProps {
    visit: TimeReportsVisitSummaryFragment;
}

export function TimeReportsVisitSummary({ visit }: TimeReportsVisitSummaryProps) {
    const { t } = useTranslation("project");

    return (
        <>
            <Box padding={2}>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.timeReportsRoute.requiredWorkers")}
                </Typography>
                <Typography>{visit.requiredFieldworkers}</Typography>
            </Box>
            <Box padding={2}>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.timeReportsRoute.start")}
                </Typography>
                {visit.startTime ? (
                    <>
                        <Typography fontWeight="bold">{formatTime(parseStringToDate(visit.startTime))}</Typography>
                        <Typography>{formatDate(parseStringToDate(visit.startTime))}</Typography>
                    </>
                ) : (
                    <Typography>—</Typography>
                )}
            </Box>
            <Box padding={2}>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.timeReportsRoute.end")}
                </Typography>
                {visit.endTime ? (
                    <>
                        <Typography fontWeight="bold">{formatTime(parseStringToDate(visit.endTime))}</Typography>
                        <Typography>{formatDate(parseStringToDate(visit.endTime))}</Typography>
                    </>
                ) : (
                    <Typography>—</Typography>
                )}
            </Box>
            <Box padding={2} sx={{ gridColumn: "-3/-1" }}>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.timeReportsRoute.plannedDuration")}
                </Typography>
                <Typography>{visit.duration ? formatSeconds(visit.duration) : "—"}</Typography>
            </Box>
        </>
    );
}
